var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/tag"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.268 21.025 8.526-8.526a3 3 0 0 0 .838-2.614l-.815-4.895a2 2 0 0 0-1.644-1.644l-4.894-.815a3 3 0 0 0-2.615.838l-8.526 8.526a3 3 0 0 0 0 4.242l4.888 4.888a3 3 0 0 0 4.242 0Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.1bfaf093c918391222c5d1d5dc2e2275.svg";
export { ForwardRef as ReactComponent };